/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any  */

import React from "react";
import ContainerUI from "@material-ui/core/Container";
import CardUI from "@material-ui/core/Card";

import { Card } from "..";
import { FrameContainerProps } from "../../utils/types/components";

export const Container = (props: any): React.ReactElement => (
  <React.Fragment>
    <ContainerUI {...props} />
  </React.Fragment>
);

export const LoginContainer = ({
  children,
}: {
  children: React.ReactElement;
}) => (
  <ContainerUI
    style={{
      display: "flex",
      flex: 1,
      justifyContent: "center",
    }}>
    <CardUI
      style={{
        verticalAlign: "center",
        marginTop: "15vh",
        marginBottom: "10vh",
      }}>
      {children}
    </CardUI>
  </ContainerUI>
);

export const FrameContainer = ({
  variant = "dashboard",
  children,
  title,
}: FrameContainerProps): React.ReactElement => {
  switch (variant) {
    case "dashboard":
      return <Card type="dashboard">{children}</Card>;

    case "custom":
      return (
        <Card type="principal" title={title}>
          {children}
        </Card>
      );

    default:
      return <div style={{ width: "100%", height: "100%" }}>{children}</div>;
  }
};
